import { ValidationResponse } from '../../../../../models/ts/validation-response';

export class MimeTypeModalData {
  public constructor(public validationResponse: ValidationResponse) {}
}
